const PROFANITY_REPLACEMENTS: Array<[RegExp, string]> = [
  [/\bfuck(?:ed|ing|s)?\b/gi, "harm"],
  [/\bshit(?:ty|s)?\b/gi, "problem"],
  [/\bdamn(?:ed)?\b/gi, ""],
  [/\bhell\b/gi, "hard situation"],
  [/\bbastard(?:s)?\b/gi, "person"],
  [/\basshole(?:s)?\b/gi, "person"],
];

const STIGMA_REPLACEMENTS: Array<[RegExp, string]> = [
  [/\byou'?ll do it again\b/gi, "future risk needs support"],
  [/\byou will do it again\b/gi, "future risk needs support"],
  [/\ba life of crime\b/gi, "a record history"],
  [/\blife of crime\b/gi, "record history"],
  [/\bcareer criminal\b/gi, "person with repeated records"],
  [/\brepeat offender\b/gi, "person with repeated records"],
  [/\brecidivis(?:m|t)\b/gi, "repeat involvement"],
];

export function scrubGeneratedCopy(input: string | null | undefined): string {
  if (!input) return "";
  let out = input
    .replace(/\s*(?:—|–|--+)\s*/g, ", ")
    .replace(/\s+-\s+/g, ", ");
  for (const [re, replacement] of PROFANITY_REPLACEMENTS) out = out.replace(re, replacement);
  for (const [re, replacement] of STIGMA_REPLACEMENTS) out = out.replace(re, replacement);
  out = out
    .replace(/\s+([,.;:!?])/g, "$1")
    .replace(/,\s*([.!?])/g, "$1")
    .replace(/([a-z0-9)])\.\s+([a-z])/g, "$1, $2")
    .replace(/([,;:])\s+([.!?])/g, "$2")
    .replace(/,\s*,+/g, ",")
    .replace(/([.!?])\s*([.!?])+/g, "$1")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
  out = removeDanglingFinalFragment(out);
  if (out && !/[.!?)]$/.test(out)) out += ".";
  return out.replace(/\s*(?:—|–|--+)\s*/g, ", ").trim();
}

function removeDanglingFinalFragment(input: string): string {
  if (!input) return input;
  const dangling = /(?:\b(?:and|or|but|because|with|without|for|to|from|that|which|who|we|we'll|we're|they|they'll|it's|that's|there's|here's|a|an|the)\b|['"`({\[])\s*$/i;
  if (!dangling.test(input) && /[.!?)]$/.test(input)) return input;
  const lastTerminal = Math.max(input.lastIndexOf("."), input.lastIndexOf("!"), input.lastIndexOf("?"));
  if (lastTerminal >= 0 && lastTerminal < input.length - 1) {
    const tail = input.slice(lastTerminal + 1).trim();
    if (tail.length < 48 || dangling.test(tail)) return input.slice(0, lastTerminal + 1).trim();
  }
  return input.replace(/[\s,;:]+$/, "").trim();
}
